import * as React from "react";
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from "uitk-react-dialog";
import { UitkText } from "uitk-react-text";
import { UitkToolbar, ToolbarType } from "uitk-react-toolbar";
import { useLocalization } from "@shared-ui/localization-context";

export const InfoDialog = ({
  infoText,
  closeDialog,
  buttonText,
}: {
  infoText?: string;
  closeDialog: () => void;
  buttonText: string;
}) => {
  const { formatText } = useLocalization();

  return (
    <UitkDialog className="uitk-scroll-vertical" returnFocusOnClose={true}>
      <UitkToolbar
        action={closeDialog}
        type={ToolbarType.CLOSE}
        iconLabel={formatText("DestinationsByAffinity.priceDialogCloseButton")}
      />
      <UitkDialogContent>
        <UitkText size={300}>
          {infoText?.split("\n").map((value, index) => (
            <p key={index}>{value}</p>
          ))}
        </UitkText>
      </UitkDialogContent>
      <UitkDialogFooter
        buttonOne={{
          onClick: closeDialog,
          text: buttonText,
          type: "tertiary",
        }}
      />
    </UitkDialog>
  );
};
